module.exports = __webpack_public_path__ + "img/remark3.71d77c2d.png";